const version ='1.6.1'
export default version
console.log(version)
